export const environment = {
    production: false,
    // API_BASE_URL: 'http://localhost:9090',
    API_BASE_URL: 'https://bhagyajitherbal.com',
    // API_BASE_URL: 'http://142.93.210.38:9090',
    // API_BASE_URL: 'http://68.183.81.178:9090',
    razorpay_key: 'rzp_live_SVtH7c7EQoC5cR',
    googleSheetApi: 'https://script.google.com/macros/s/AKfycbzLYpnNHY-18j--XD29FOjgnPZfzv_oV1lIwIpbNYNzHW-swBDSKxbz2CMxKkjy762bqA/exec',
    statesApi : 'https://countriesnow.space/api/v0.1/countries/states',
    RTOAdressId: '88403',
    paymentSuccessMsg: 'Payment Successful!!!\n' +
        'Your order is confirmed, here is your order id - "{ORDER_ID}".\n' +
        '\n' +
        'You will be notified through our delivery partners once parcel  picked for shipment.',
};
